$shm_hitalama_map_book $mol_book2
	placeholders /
	menu_title <= title \
	pages /
		<= Page $mol_view
			title <= title
			sub <= page_sub /
				<= Head $shm_hitalama_map_head
					map <= map
					zoom? <=> zoom?
					shift? <=> shift?
					map_cut <= map_cut null
					widget_headers_visible? => widget_headers_visible?
					widget_list_visible? => widget_list_visible?
					file_list_visible? => file_list_visible?
					editor_mode_enabled? => editor_mode_enabled?
					arrows_visible? => arrows_visible?
				- <= Tool_modes
				^ widget_list_view /
					<= Widgets $shm_hitalama_map_book_widgets3
						map <= map
						Map_page <= Map_page
						editor_mode_enabled <= editor_mode_enabled
						widget_list_visible? <=> widget_list_visible?
				^ map_or_editor /
					<= Map_page $shm_hitalama_map_page
						entity <= entity $giper_baza_entity
						cut <= map_cut null
						map => map
						zoom? => zoom?
						shift? => shift?
						widgets_filtered => widgets_filtered
						selected_links => selected_links
						- Open_in_new null
						go_to_widget* => go_to_widget*
						Widget* => Widget*
						widget_headers_visible <= widget_headers_visible
						arrows_visible <= arrows_visible
						tool_mode? <=> tool_mode?
					<= Editor $shm_hitalama_map_editor
						map <= map
						widget <= widget_for_editor null
						Widget* <= Widget*
		^ widget_props_visible /
			<= Widget_props $shm_hitalama_map_widget_page
				widget <= widget_for_settings null
				Map_page <= Map_page
	Tool_modes $shm_hitalama_map_book_tools
		tool_mode? <=> tool_mode? \
		style *
			left <= tool_modes_left \18rem
	Presets_page $shm_hitalama_map_widget_presets_page
		Map_page <= Map_page
	Widgets_visible $mol_check_icon
		checked? <=> widget_list_visible?
		Icon <= Widgets_visible_icon $mol_icon_format_list_bulleted
